import { render, staticRenderFns } from "./WBtn.vue?vue&type=template&id=22c8823b&"
import script from "./WBtn.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtn.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports